import { useQueryClient } from '@tanstack/react-query';
import { RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY } from 'hooks/queries/useGetRiskManagementLastConsultations';
import { SEARCH_TRUCKER_KEY } from 'hooks/queries/useOpenSearchQuery';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';

const useClearOpenSearch = () => {
  const {
    setInputHasError,
    setIsTextFieldFocus,
    setValueInputSearch,
    setIsCardVisible,
    setIsModalJourneyVisible,
    setIsBenefitsModalOpen,
    setIsLastSearchedDriversVisible,
    setIsProfileVisible,
    setIsKebabVisible,
    setIsInputSearchMasked,
  } = useOpenSearchContext();

  const queryClient = useQueryClient();

  const invalidateOpenSearchQuery = () => {
    queryClient.removeQueries({ queryKey: [SEARCH_TRUCKER_KEY], type: 'all' });
    queryClient.removeQueries({ queryKey: [RISK_MANAGEMENT_LAST_CONSULTATIONS_QUERY_KEY], exact: false });
  };

  const clearOpenSearch = () => {
    setValueInputSearch('');
    setIsTextFieldFocus(false);
    setInputHasError(false);
    setIsCardVisible(false);
    setIsModalJourneyVisible(false);
    setIsBenefitsModalOpen(false);
    setIsLastSearchedDriversVisible(false);
    setIsProfileVisible(false);
    setIsKebabVisible(false);
    setIsInputSearchMasked(false);
    invalidateOpenSearchQuery();
  };

  return { clearOpenSearch, invalidateOpenSearchQuery };
};

export { useClearOpenSearch };
